export class LockMechanism {
    private isLocked: boolean = false;
    private pendingCallbacks: Array<() => void> = [];

    public logOutOfLockCb(cb: () => void): void {
        if (this.isLocked) {
            this.pendingCallbacks.push(cb);
        } else {
            cb();
        }
    }

    public async executeLock(cb: () => Promise<void>): Promise<void> {
        if (this.isLocked) {
            throw new Error("Cannot execute lock while already locked.");
        }

        this.isLocked = true;

        try {
            await cb();
        } finally {
            const callbacksToExecute = [...this.pendingCallbacks];
            this.pendingCallbacks = [];
            this.isLocked = false;

            for (const pendingCb of callbacksToExecute) {
                try {
                    pendingCb();
                } catch (error) {
                    console.error("Error executing pending callback:", error);
                    // Decide if you want to re-throw or handle otherwise
                }
            }
        }
    }
}

export class _LockMechanism {
    private isLocked: boolean = false;
    private pendingCallbacks: Array<{ generator: (() => Promise<void>), resolve: () => void }> = [];

    public async executeLock(cb: () => Promise<void>): Promise<void> {
        if (this.isLocked) {
            return new Promise<void>((resolve) => {
                this.pendingCallbacks.push({
                    generator: cb,
                    resolve,
                });
            });
        }
        else {
            this.isLocked = true;
            await cb();
            while (this.pendingCallbacks.length > 0) {
                const pendingCallbacks = [...this.pendingCallbacks];
                this.pendingCallbacks.length = 0;
                for (const { generator, resolve } of pendingCallbacks) {
                    await generator();
                    resolve();
                }
            }
            this.isLocked = false;
        }
    }
}